import { useEffect, useRef, useState } from 'react'

/**
 * 滚动揭示动画容器 —— 基于 IntersectionObserver，无第三方依赖。
 * 子元素进入视口时添加 is-in，配合 .reveal 的 CSS 过渡。
 */
function Reveal({ as: Tag = 'div', delay = 0, className = '', style, children, ...rest }) {
  const ref = useRef(null)
  const [shown, setShown] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node) return

    if (typeof IntersectionObserver === 'undefined') {
      setShown(true)
      return
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShown(true)
            io.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    )

    io.observe(node)
    return () => io.disconnect()
  }, [])

  const cls = ['reveal', shown ? 'is-in' : '', className].filter(Boolean).join(' ')

  return (
    <Tag
      ref={ref}
      className={cls}
      style={{ ...style, '--reveal-delay': `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  )
}

export default Reveal